<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <center style="width: 100%"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="departmentLoader == true"/></center>
        <v-tabs slider-color="grey" v-if="departmentLoader == false">
          <v-tab class="tab" :key="1" ripple>Deparment Details</v-tab>
          <v-tab class="tab" :key="2" ripple>Department Calculator</v-tab>
          <v-tab class="tab" :key="3" ripple>Department Product Codes</v-tab>
          <v-tab class="tab" :key="4" ripple>Department Status Rules</v-tab>
          <v-tab class="tab" :key="5" ripple>Department Quote Edit Screen</v-tab>
          <!--<v-tab class="tab" :key="3" ripple>Miscellaneous</v-tab>-->
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg6>
                  <label class="blackLabel">* Department Name:</label>
                  <v-text-field label="Name" v-model="departmentName" required :rules="nameRules" single-line
                                solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Department Description:</label>
                  <v-text-field label="Description" v-model="departmentDescription" required :rules="descriptionRules"
                                single-line solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Department Terms & Conditions Link:</label>
                  <v-text-field label="Terms & Conditions Link" v-model="departmentTerms" required single-line
                                solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Department Sales Margin:</label>
                  <v-text-field label="Department Margin" v-model="departmentMargin" single-line
                                solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Department Installation Margin:</label>
                  <v-text-field label="Department Margin" v-model="departmentInstallationMargin" single-line
                                solo></v-text-field>
                </v-flex>
                <!--<v-flex lg6>
                  <label class="blackLabel">* Department Vendor:</label>
                  <v-select label="Vendor" class="dropdown" v-model="departmentVendor" :items="vendorList"item-value="id" item-text="name" autocomplete solo single-line></v-select>
                </v-flex>-->
                <!--<v-flex lg4>
                  <label class="blackLabel">Department Store:</label>
                  <v-select :items="branchList" v-model="departmentBranch" item-value="id" :rules="branchRules" item-text="name" label="Department Branch" autocomplete solo multiple></v-select>
                </v-flex>-->
                <!--<v-flex lg4>
                  <label class="blackLabel">Department Extension:</label>
                  <v-text-field label="Extension" v-model="departmentExtension" required single-line solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Department Address:</label>
                  <v-text-field label="Address" v-model="departmentAddress" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Department Contact Number:</label>
                  <v-text-field label="Contact Number" v-model="departmentContactNumber" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Department Contact Person:</label>
                  <v-text-field label="Contact Person" v-model="departmentContactPerson" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Department Email:</label>
                  <v-text-field label="Email" v-model="departmentEmail" single-line solo></v-text-field>
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <label class="blackLabel">Department Ranges:</label>
                  <v-select :items="departmentRangesList" v-model="departmentRanges" item-value="id32"
                            :rules="branchRules" item-text="name" label="Department Ranges" autocomplete solo
                            multiple></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg12>
                  <input type="file" id="articleImport" @change="fncSetImageObj">
                </v-flex>
                <v-flex lg3 v-for="(product_code, index) in product_codes">
                  <v-text-field label="Product Code" v-model="product_codes[index].value" single-line
                                solo></v-text-field>
                  <a @click="fncRemoveDepartmentRange(index)" class="departmentRangeRemove">Remove</a>
                </v-flex>
                <v-flex lg3>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncAddProductCode()">Add Product Code
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12>
                  <v-btn color="info" @click="fncAddStatusRules">Add Rule</v-btn>
                </v-flex>
                <v-data-table loading="true" :headers="headers" :items="statusRules" v-if="statusRules.length > 0"
                              hide-actions disable-initial-sort class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <tr class="sortableRow" id="rows">
                      <td width="15%">
                        <v-select style="margin-top: 4px !important;" :items="serviceType" placeholder="Service Type"
                                  class="dropdown" v-model="props.item.type" item-value="id" item-text="name" outline
                                  autocomplete></v-select>
                      </td>
                      <td width="20%">
                        <v-select style="margin-top: 4px !important;" :items="userRoles" placeholder="Roles"
                                  class="dropdown" v-model="props.item.originator" item-value="id" item-text="name"
                                  multiple outline autocomplete></v-select>
                      </td>
                      <td width="25%">
                        <v-select style="margin-top: 4px !important;" :items="userRoles" placeholder="Roles"
                                  class="dropdown" v-model="props.item.roles" item-value="id" item-text="name" multiple
                                  outline autocomplete></v-select>
                      </td>
                      <td width="15%">
                        <v-select style="margin-top: 4px !important;" :items="designationType" placeholder="Designation"
                                  class="dropdown" v-model="props.item.designation" item-value="id" item-text="name"
                                  multiple outline autocomplete></v-select>
                      </td>
                      <td width="15%">
                        <v-select style="margin-top: 4px !important;" :items="statusList" placeholder="Status"
                                  class="dropdown" v-model="props.item.status" item-value="id" item-text="description"
                                  outline autocomplete></v-select>
                      </td>
                      <td width="10%"><a @click="fncDeleteStatusRule(props.item)">Delete</a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <v-container grid-list-xl style="padding-top: 10px !important;">
              <v-layout row wrap>
                <v-flex lg6>
                  <label class="blackLabel">Can Add More Rows</label>
                  <v-switch v-model="canAddRows" single-line solo></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Has Linked Line Items</label>
                  <v-switch v-model="linkedItems" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Calculator</label>
                  <v-switch v-model="calculator" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Location</label>
                  <v-switch v-model="location" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Article Description</label>
                  <v-switch v-model="articleDescription" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">BW Article No.</label>
                  <v-switch v-model="bwArticleNo" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Vendor</label>
                  <v-switch v-model="vendor" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Plant Code</label>
                  <v-switch v-model="plantCode" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Product Description</label>
                  <v-switch v-model="productDescription" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Quantity</label>
                  <v-switch v-model="quantity" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">UOM</label>
                  <v-switch v-model="uom" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Hire Date</label>
                  <v-switch v-model="hireDate" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Hire Period</label>
                  <v-switch v-model="hirePeriod" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Delivery Method</label>
                  <v-switch v-model="deliveryMethod" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Receival Time</label>
                  <v-switch v-model="receivalTime" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Unit Selling Price ( ex VAT )</label>
                  <v-switch v-model="unitSellingPriceExVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Unit Vat</label>
                  <v-switch v-model="unitVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Unit Total ( inc VAT )</label>
                  <v-switch v-model="unitTotalIncVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Total (inc VAT)</label>
                  <v-switch v-model="totalIncVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Vendor Unit Cost (ex VAT)</label>
                  <v-switch v-model="vendorUnitCostExVat" single-line solo></v-switch>
                </v-flex>
                <v-flex lg3>
                  <label class="blackLabel">Margin</label>
                  <v-switch v-model="margin" single-line solo></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-1 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey"
                                 class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="addressSelected == false" :disabled="true"
                   @click.stop="fncAddDepartment()">Save
            </v-btn>
            <!--<v-btn color="success" class="text-xs-right" v-else :disabled="update_vars" @click.stop="fncAddDepartment()">Save-->
            <v-btn color="success" class="text-xs-right" v-else @click.stop="fncAddDepartment()">Save
            </v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';
  import PeriodSelector from "../components/PeriodSelector";
  import StatusSelector from "../components/StatusSelector";

  export default {
    name: 'Settings',
    components: {PeriodSelector, StatusSelector},
    data() {
      return {
        canAddRows: false,
        linkedItems: false,
        calculator: true,
        location: true,
        articleDescription: true,
        bwArticleNo: true,
        vendor: true,
        plantCode: true,
        productDescription: true,
        quantity: true,
        uom: true,
        hireDate: false,
        hirePeriod: false,
        deliveryMethod: false,
        receivalTime: false,
        unitSellingPriceExVat: true,
        unitVat: true,
        unitTotalIncVat: true,
        totalIncVat: true,
        vendorUnitCostExVat: true,
        margin: true,
        statusRules: [],
        isAddValid: false,
        articleImport: '',
        search: '',
        departmentName: '',
        departmentBranch: '',
        departmentExtension: '',
        departmentAddress: '',
        departmentVendor: 0,
        departmentContactNumber: '',
        departmentContactPerson: '',
        departmentEmail: '',
        departmentBank: '',
        departmentTnc: '',
        departmentRanges: [],
        departmentTerms: '',
        departmentMargin: '',
        serviceType: [
          {id: 1, name: 'Contact Customer'},
          {id: 2, name: 'Request Quote'},
          {id: 3, name: 'Request Measure To Quote'},
          {id: 4, name: 'Request Measure To Quote - No Call Out Fee'},
          {id: 5, name: 'Request Calculator'}
        ],
        designationType: [
          {id: 1, name: 'Service Form'},
          {id: 2, name: 'App'}
        ],
        departmentDescription: '',
        headers: [
          {text: 'Service Type', value: 'name', width: '15%'},
          {text: 'Originator', value: 'description', width: '20%'},
          {text: 'Process Roles To Display', value: 'description', width: '25%'},
          {text: 'Designation', value: 'created_on', width: '15%'},
          {text: 'Status', value: 'created_on', width: '15%'},
          {text: 'Delete', value: 'delete', width: '10%'}
        ],
        nameRules: [
          v => !!v || 'Department name is required',
        ],
        descriptionRules: [
          v => !!v || 'Department description is required',
        ],
        branchRules: [
          v => !!v || 'Department store is required',
        ],
        addressSelected: true,
        overrideBank: false,
        product_codes: [{value: ''}],
        objWidgetEdit: {
          statusList: this.departmentStatuses,
          headers: [
            {
              text: 'Group',
              align: 'left',
              sortable: false,
              value: 'label'
            },
            {
              text: 'Initial Status',
              align: 'center',
              sortable: false,
              value: 'status_initial'
            },
            {
              text: 'End Status',
              align: 'center',
              sortable: false,
              value: 'status_end'
            },
            {
              text: 'Period',
              align: 'center',
              sortable: false,
              value: 'period'
            }
          ],
          widgets: {
            ESCALATION: {
              title: 'Escalation Widget',
              groups: {
                'Customer Requirements not Finalised': {
                  value: false,
                  label: 'Customer Requirements not Finalised',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Requirements not sent to Design Team': {
                  value: false,
                  label: 'Requirements not sent to Design Team',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Quote not yet completed by Design Team': {
                  value: false,
                  label: 'Quote not yet completed by Design Team',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have followed up': {
                  value: false,
                  label: 'Should have followed up',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have got Answer from customer': {
                  value: false,
                  label: 'Should have got Answer from customer',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have sent Updated quote': {
                  value: false,
                  label: 'Should have sent Updated quote',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have checked out by now': {
                  value: false,
                  label: 'Should have checked out by now',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have been Manufactured': {
                  value: false,
                  label: 'Should have been Manufactured',
                  status_initial: {},
                  status_end: {},
                  period: ''
                },
                'Should have been Delivered': {
                  value: false,
                  label: 'Should have been Delivered',
                  status_initial: {},
                  status_end: {},
                  period: ''
                }
              }
            }
          },
        }
      };
    },
    methods: {
      fncDeleteStatusRule(rule) {

        var newRules = [];
        for (var r in this.statusRules) {
          if (this.statusRules[r].id != rule.id) {
            newRules.push(this.statusRules[r]);
          }
        }

        this.statusRules = newRules;
      },
      fncAddStatusRules() {
        var ruleId = this.statusRules.length + 1;
        var newRule = {id: ruleId, type: '', originator: [], roles: [], designation: [], status: ''}
        this.statusRules.push(newRule);
      },
      fncSetImageObj(e) {
        var files = e.target.files || e.dataTransfer.files;
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          var articleNumbers = reader.result;
          var articleRows = articleNumbers.split("\r\n");
          if (articleRows.length > 0) {
            vm.product_codes = [];
            for (var a in articleRows) {
              if (articleRows[a] != '') {
                vm.product_codes.push({value: articleRows[a]});
              }
            }
          }
          /*vm.objRows = articleNumbers.split("\r\n");
          vm.fileName = files[0].name;*/
        }
        reader.readAsText(files[0]);
      },
      fncRemoveDepartmentRange(index) {
        var newProductCodes = [];
        for (var i in this.product_codes) {
          if (i != index) {
            newProductCodes.push(this.product_codes[i]);
          }
        }
        if (newProductCodes.length == 0) {
          newProductCodes = [{value: ''}];
        }
        this.product_codes = newProductCodes;
      },
      fncAddProductCode() {
        this.product_codes.push({value: ''});
      },
      fncHideModal() {
        this.$store.commit('hideModal');
      },
      fncCheckRegionSetup(regionId, regionStatus, regionParent) {
        this.addressSelected = true;
        this.$store.commit({
          type: 'fncCheckRegionSetup',
          regionId: regionId,
          regionStatus: regionStatus,
          parent: regionParent
        })
        if (regionStatus == false) {
          this.$store.commit('fncHideRegionParent', regionParent)
        }
      },
      fncAddDepartment() {

        var editForm = {};
        editForm.linkedItems = this.linkedItems;
        editForm.calculator = this.calculator;
        editForm.location = this.location;
        editForm.articleDescription = this.articleDescription;
        editForm.bwArticleNo = this.bwArticleNo;
        editForm.vendor = this.vendor;
        editForm.plantCode = this.plantCode;
        editForm.productDescription = this.productDescription;
        editForm.quantity = this.quantity;
        editForm.uom = this.uom;
        editForm.hireDate = this.hireDate;
        editForm.hirePeriod = this.hirePeriod;
        editForm.deliveryMethod = this.deliveryMethod;
        editForm.receivalTime = this.receivalTime;
        editForm.unitSellingPriceExVat = this.unitSellingPriceExVat;
        editForm.unitVat = this.unitVat;
        editForm.unitTotalIncVat = this.unitTotalIncVat;
        editForm.totalIncVat = this.totalIncVat;
        editForm.vendorUnitCostExVat = this.vendorUnitCostExVat;
        editForm.margin = this.margin;

        this.$store.dispatch({
          type: 'fncAddDepartment',
          departmentDetails: {
            deparmentName: this.departmentName,
            departmentDescription: this.departmentDescription,
            departmentExtension: this.departmentExtension,
            departmentAddress: this.departmentAddress,
            departmentContactNumber: this.departmentContactNumber,
            departmentContactPerson: this.departmentContactPerson,
            departmentEmail: this.departmentEmail,
            departmentBank: this.departmentBank,
            departmentTnc: this.departmentTnc,
            departmentBranch: this.departmentBranch,
            departmentOverride: this.overrideBank,
            departmentRanges: this.departmentRanges,
            departmentVendor: this.departmentVendor,
            product_codes: this.product_codes,
            terms: this.departmentTerms,
            departmentMargin: this.departmentMargin,
            departmentInstallationMargin: this.departmentInstallationMargin,
            statusRules: this.statusRules,
            canAddRows: this.canAddRows,
            linkedItems: this.linkedItems,
            editForm: editForm
            //departmentRegions: this.userRegions
          }
        });
      },
      update_vars() {
        /*if (this.isAddValid && this.product_codes.every(item => item.value !== '')) {

          console.log('here');
          return false
        } else {
          return true
        }*/
      }
    },
    beforeMount() {
      this.$store.dispatch('fncPopulateVendors');
      this.$store.dispatch('fncPopulateRoles');
      this.$store.commit('fncEmptyStatusList');
      this.$store.dispatch('fncPopulateStatusList');
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'runAdd',
        //'userRegions',
        'branchList',
        'departmentRangesList',
        'departmentStatuses',
        'departmentLoader',
        'departmentUsedRanges',
        'vendorList',
        'userRoles',
        'statusList'
      ])
    },
    created() {
      this.$store.dispatch('fncPopulateBranches');
      //this.$store.dispatch('fncPopulateRegionList');
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
